import AppConfig from "./AppConfig";
import { BrowserUtil } from "./BrowserUtil";
import EnvUtil from "./EnvUtil";
// migrate from @aperza/util as standalone
var AppService = /** @class */ (function () {
    function AppService() {
    }
    AppService.cloudServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://dx.local.aperza.com:18010';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://dx.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://dx.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://dx.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://dx.aperza.com';
        }
        return serverUrl;
    };
    AppService.wwwServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://www.local.aperza.com:8280';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://www.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://www.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://www.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://www.aperza.com';
        }
        return serverUrl;
    };
    AppService.ecServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://ec.local.aperza.com:8081';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://ec.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://ec.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://ec.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://ec.aperza.com';
        }
        return serverUrl;
    };
    AppService.orderServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://order.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://order.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://order.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://order.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://order.aperza.com';
        }
        return serverUrl;
    };
    AppService.businessServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://business.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://business.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://business.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://business.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://business.aperza.com';
        }
        return serverUrl;
    };
    AppService.tvServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://tv.local.aperza.com:8050';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://tv.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://tv.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://tv.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://tv.aperza.com';
        }
        return serverUrl;
    };
    AppService.newsServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://news.test.aperza.jp'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://news.test.aperza.jp';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://news.stg.aperza.jp';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://news.aperza.jp';
        }
        return serverUrl;
    };
    AppService.staticServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://static.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://static.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://static.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://static.aperza.com';
        }
        return serverUrl;
    };
    AppService.trApiServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://tr.api.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://tr.api.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://tr.api.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://tr.api.aperza.com';
        }
        return serverUrl;
    };
    AppService.mailApiServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://mail-api.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://mail-api.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://mail-api.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://mail-api.aperza.com';
        }
        return serverUrl;
    };
    AppService.accountServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://account.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://account.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://account.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://account.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://account.aperza.com';
        }
        return serverUrl;
    };
    AppService.idServerHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://id.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://id.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://id.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://id.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://id.aperza.com';
        }
        return serverUrl;
    };
    AppService.cluezMemberHost = function () {
        var env = EnvUtil.getAppEnv();
        var serverUrl = 'https://member.test.cluez.biz';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://member.test.cluez.biz';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://member.test2.cluez.biz';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://member.stg.cluez.biz';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://member.cluez.biz';
        }
        return serverUrl;
    };
    AppService.webServerHost = function () {
        var env = EnvUtil.getAppEnv();
        // let serverUrl = 'https://web.local.aperza.com:9020';
        var serverUrl = 'https://web.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://web.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://web.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://web.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://web.aperza.com';
        }
        return serverUrl;
    };
    AppService.encodedPath = function (serviceType) {
        var encodedPath = '';
        // https://aperza.atlassian.net/browse/AB-5120
        // Exception for order
        if (serviceType === AppConfig.APERZA_ORDER) {
            return encodedPath;
        }
        var path = (BrowserUtil.getPath() + BrowserUtil.getSearch()).replace(/^\/+/, '');
        if (path !== '/') {
            encodedPath = encodeURIComponent(path);
        }
        return encodedPath;
    };
    AppService.checkEncodedPath = function (serviceType) {
        // https://aperza.atlassian.net/browse/AB-20616
        // add encodedPath if the path NOT exists
        // avoid duplicate encodedPath on multiple attempt access on login page
        var urlParams = new URL(window.location.href).searchParams;
        if (urlParams.has('path')) {
            return urlParams.get('path');
        }
        return this.encodedPath(serviceType);
    };
    return AppService;
}());
export default AppService;
export { AppService };
